import { Logo } from './Logo';
import { Spinner } from './ui';

export function Splash() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6">
      <Logo className="h-9" />
      <Spinner label="Loading your dashboard" />
    </div>
  );
}
